import React from 'react';

import { useReviewModules } from 'features/reviewModules/useReviewModules';
import SingleRevision from 'features/submissions/components/atoms/SingleRevision';
import { useSubmissions } from 'features/submissions/useSubmissions';
import { Box } from 'shared/components/display';

import { useCurrentUser } from 'shared/hooks/useCurrentUser';
import { Revision } from 'shared/typings/revisions';

interface Props {
  revisions?: Revision[];
  brandName: string;
}

const RevisionsList: React.FC<Props> = ({ revisions = [], brandName }) => {
  const { isCreator } = useCurrentUser();
  const { submissions } = useSubmissions();

  // Get the moduleId from the first revision to find the current module
  const moduleId = revisions[0]?.submissionModuleId;
  const { allModules } = useReviewModules();

  // Get the module from the review modules store to get real-time updates
  const currentModule = allModules.find((module) => module.id === moduleId);

  // Find revisions from submissions store as a fallback
  const submissionModuleFromStore = submissions
    .flatMap((submission) => submission.moduleSubmissions)
    .find((module) => module.id === moduleId);

  // Use revisions from Redux store if available (for real-time updates),
  // fallback to submissions store, then finally to props
  const revisionsToDisplay = currentModule?.revisions || submissionModuleFromStore?.revisions || revisions;

  return (
    <Box>
      {revisionsToDisplay.map((revision) => (
        <SingleRevision
          key={revision.id}
          revision={revision}
          brandName={brandName}
          isCreator={isCreator}
          submissionModuleId={revision.submissionModuleId}
        />
      ))}
    </Box>
  );
};

export default RevisionsList;
